import { getConfigWithKeys } from '@cibo/core'

export type CIBO_UI_CONFIG = 'MAP_THUMBNAIL_URL'

export const Config = getConfigWithKeys<CIBO_UI_CONFIG>()
